/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var CategoriesOutlineIcon = function CategoriesOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11ZM17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.86641C11 3.20695 8.99364 2.37588 7.82022 3.5493L3.5493 7.82021C2.37588 8.99363 3.20694 11 4.86641 11H9.13732C10.1661 11 11 10.1661 11 9.13732V4.86641ZM5 9L9 5V9H5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13C13.8954 13 13 13.8954 13 15V19C13 20.1046 13.8954 21 15 21H19C20.1046 21 21 20.1046 21 19V15C21 13.8954 20.1046 13 19 13H15ZM19 15V19H15V15H19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 20.75L7 18.5L4.75 20.75L3.25 19.25L5.5 17L3.25 14.75L4.75 13.25L7 15.5L9.25 13.25L10.75 14.75L8.5 17L10.75 19.25L9.25 20.75Z"
  }));
};
export default CategoriesOutlineIcon;